// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  overflow: auto;
}

.mainBody {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 20px;
  min-height: 90%;
}`, "",{"version":3,"sources":["webpack://./src/app/main-layout/main-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AACJ","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 100%;\n  overflow: auto;\n}\n\n.mainBody {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    align-content: stretch;\n    margin-left: 10%;\n    margin-right: 10%;\n    margin-bottom: 20px;\n    min-height: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
